import { useFeatureFlagVariantKey } from "posthog-js/react";

/**
 * A/B test hook — returns the variant assigned to the current user.
 *
 * Usage:
 *   const variant = useABTest('homepage-hero-cta');
 *   // variant === 'control' | 'variant-a' | 'variant-b' | null
 *
 * Variants are defined in the PostHog dashboard under Feature Flags.
 * null means the flag hasn't loaded yet — always render the control in that case.
 */
export function useABTest(flagKey: string): string {
  const variant = useFeatureFlagVariantKey(flagKey);
  // Default to 'control' while loading or if flag is undefined
  return (variant as string) || "control";
}
